import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SiqApplicationsRoutes } from 'app/siq-applications/routes/siq-applications-routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(SiqApplicationsRoutes)
  ],
  exports: [ RouterModule ]
})

export class SiqApplicationsRoutingModule { }
